export default __webpack_public_path__ + "static/media/logo.d7c9d47d.svg";